import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const PageNotFound = () => {
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate("/"); // Replace with your desired route
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "40vh",
				textAlign: "center",
				p: 3,
			}}>
			<ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
			<Typography variant="h4" color="textPrimary" gutterBottom>
				404 - Page Not Found
			</Typography>
			<Typography variant="body1" color="textSecondary" gutterBottom>
				The page you are looking for doesn't exist or has been moved.
			</Typography>
			<Button variant="contained" color="primary" onClick={handleGoHome} sx={{ mt: 2 }}>
				Go to Homepage
			</Button>
		</Box>
	);
};

export default PageNotFound;
